<template>
    <div
        class="bg-gray-300 dark:bg-jackpot-bg text-gray-900 dark:text-inner-border absolute top-0 right-0 bottom-0 overflow-auto z-30"
        :class="accountMenuShow ? 'w-72 lg:w-80' : 'w-0'"
        v-click-outside="vcoConfig"
    >
        <div class="h-screen flex flex-col">

            <div class="h-16 flex items-center justify-center relative drop-shadow-lg text-white">
                <span class="p-2 text-base">Account</span>
                <div class="absolute right-0 top-0 bottom-0 flex items-center justify-center">
                    <div class="h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center mx-2" @click="toggleAccountMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                </div>
            </div>

            <ul class="bg-gray-100 dark:bg-lobby-bg flex-1 text-sm">

                <li v-if="connected && !authenticated" @click="login" class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer">
                    <i class="fa-light fa-right-to-bracket text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Login
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="changeName"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-user text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Name
                    </div>
                    <div class="text-gray-500 dark:text-white flex-1 text-right mr-1">
                        {{ account.name }}
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="changePfp"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-image-portrait text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        PFP
                    </div>
                    <div class="flex-1 flex items-center justify-end text-gray-500 dark:text-white">
                        <img v-if="account.pfp" class="block rounded-full object-cover h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 border-2 border-gray-400 dark:border-white" :src="account.pfp" />
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                            <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clip-rule="evenodd" />
                        </svg>
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="deposit"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-arrow-down-to-bracket text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Deposit
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="withdraw"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-arrow-up-from-bracket text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Withdraw
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="swapTokens"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-right-left text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Swap Gems
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="spin"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-rotate text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Spin
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="transactions"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-receipt text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Transactions
                    </div>
                </li>

                <li v-if="connected && authenticated"
                    @click="revenue"
                    class="flex items-center gap-2 max-[320px]:gap-1 max-[320px]:p-1 p-2 hover:bg-gray-200 dark:hover:bg-gray-900 cursor-pointer"
                >
                    <i class="fa-light fa-sack-dollar text-xl max-[320px]:text-lg h-8 w-8 max-[320px]:h-6 max-[320px]:w-6 flex items-center justify-center text-blue-500 dark:text-outter-border"></i>
                    <div>
                        Revenue
                    </div>
                </li>

                <hr v-if="connected && authenticated" class="my-1 mx-auto w-36 h-1 bg-blue-200 rounded border-0 dark:bg-jackpot-bg" />

                <li v-if="connected && authenticated" class="mt-3 ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Balance:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ balance }}</span> SOL
                    </div>
                </li>

                <li v-if="connected && authenticated" class="ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Played:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ played }}</span>
                    </div>
                </li>

                <li v-if="connected && authenticated" class="ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Wagered:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ wagered }}</span> SOL
                    </div>
                </li>

                <li v-if="connected && authenticated" class="ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Joined:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ joined }}</span>
                    </div>
                </li>

                <li class="ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Online:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ online }}</span>
                    </div>
                </li>

                <li class="ml-2 flex flex-col items-start justify-center gap-1 max-[320px]:p-1 p-2 text-sm">
                    <div class="uppercase text-gray-500 dark:text-outter-border">Version:</div>
                    <div class="text-gray-600 dark:text-white">
                        <span class="font-semibold">{{ version }}</span>
                    </div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
import * as dayjs from 'dayjs'
import solana from '../mixins/solana'
import vClickOutside from 'click-outside-vue3'

export default {
    name: 'AccountMenu',
    props: ['accountMenuShow', 'isDark', 'authenticated', 'connected', 'account', 'pusherState', 'online', 'version'],
    mixins: [ solana ],
    directives: { clickOutside: vClickOutside.directive },
    data() {
        return {
            vcoConfig: {
                handler: this.onClickOutside,
                events: ["dblclick", "click"],
                capture: true
            }
        }
    },
    computed: {
        joined() {
            return dayjs(this.account.created_at).format('DD/MM/YYYY HH:mm')
        },
        balance() {
            return this.lamportsToSol(this.account.balance)
        },
        played() {
            return this.account.played
        },
        wagered() {
            return Math.abs(this.lamportsToSol(this.account.wagered))
        }
    },
    methods: {
        onClickOutside (e) {
            const target = e.target.matches('button.swv-button')
            if (!target) {
                e.stopPropagation()
            }
            this.emitter.emit('account-menu-toggle')
        },
        toggleAccountMenu() {
            this.emitter.emit('account-menu-toggle')
        },
        login() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('login')
        },
        changeName() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'name_modal')
        },
        changePfp() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'pfp_modal')
        },
        deposit() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'deposit_modal')
        },
        withdraw() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'withdraw_modal')
        },
        swapTokens() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'swap_tokens_modal')
        },
        spin() {
            this.emitter.emit('account-menu-toggle')
            this.emitter.emit('open-modal', 'spin_modal')
        },
        transactions() {
            this.emitter.emit('transactions-show')
            this.emitter.emit('account-menu-toggle')
        },
        revenue() {
            this.emitter.emit('revenue-show')
            this.emitter.emit('account-menu-toggle')
        }
    }
}
</script>
